import Money from './Money';

/** Dải "Tổng chi" = tiền ra khỏi ví (chi từ ví + trả thẻ & nợ; chi quẹt thẻ tính khi trả thẻ): dự kiến cả kỳ, đã chi, còn phải chi. */
export default function SpendTotals(p: { planned: number; done: number; left: number; doneLabel?: string; note?: string; loading?: boolean }) {
  const items = [
    { l: 'Tổng chi dự kiến', v: p.planned }, { l: p.doneLabel ?? 'Đã chi', v: p.done }, { l: 'Còn phải chi', v: p.left, strong: true }
  ];
  return (
    <div className="rounded-md border border-border bg-secondary/40 p-3" role="group" aria-label="Tổng chi gồm chi từ ví và trả thẻ & nợ">
      <p className="mb-2 text-sm font-medium">Tổng chi <span className="font-normal text-muted-foreground">(tiền ra khỏi ví: chi từ ví + trả thẻ &amp; nợ)</span></p>
      <dl className="grid grid-cols-3 gap-x-4">
        {items.map(x => (
          <div key={x.l} className="min-w-0">
            <dt className="text-sm text-muted-foreground">{x.l}</dt>
            <dd className={x.strong ? 'font-semibold' : undefined}>{p.loading ? <span className="text-muted-foreground">…</span> : <Money value={x.v} size="row" compact />}</dd>
          </div>
        ))}
      </dl>
      {p.note && <p className="mt-2 text-sm text-muted-foreground">{p.note}</p>}
    </div>
  );
}
